// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */
.sidebar-root {
    position: static;
    height: 100vh;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    display: flex;
    flex-direction: column;
    font-size: 15px;
    z-index: 10000;
    box-shadow: 0px 10px 16px 4px rgba(4, 0, 43, 0.07);
    width: 70px;
    overflow: visible;
    transition: width 2s ease;
  }
  
  .sidebar-root.collapsed {
    width: 70px;
    transition: width 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  
  .sidebar-root.expanded {
    width: 18rem;
    transition: width 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  
  .sidebar-logo {
    flex-direction: row;
    width: 9vw;
    height: 9vh;
    padding-left: 4vh;
  }
  
  .dark-sidebar-menu-text {
    padding-top: 4vh;
    margin-bottom: 1vh;
    letter-spacing: 0.5px;
  }
  
  .light-sidebar-menu-text {
    padding-top: 4vh;
    margin-bottom: 2vh;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
  
  .sidebar-menu-items {
    padding-left: 2vh;
    padding-right: 2vh;
  }
  
  .sidebar-active-menu {
    display: flex;
    padding: 0.9vh;
    background-color: #ff4e3a;
    color: #ffffff;
    border-radius: 0.8vh;
    margin: 1.6vh;
    cursor: pointer;
    align-items: center;
  }
  
  .sidebar-in-active-menu {
    display: flex;
    padding: 0.5vh;
    border-radius: 1vh;
    margin: 2vh;
    cursor: pointer;
    align-items: center;
  }
  
  .sidebar-home-icon,
  .sidebar-home-icon2 {
    width: fit-content;
    height: 1rem;
  }
  
  .sidebar-root,
  .sidebar-menu-items,
  .sidebar-home-icon,
  .sidebar-home-icon2 {
    transition: opacity 2s ease;
  }

  .ant-switch-checked {
    background-color: #ff4e3a !important;
  }
  
  .ant-switch-checked:hover:not(.ant-switch-disabled) {
    background-color: #ff4e3a !important;
  }
  
  .ant-switch-checked:focus {
    box-shadow: 0 0 0 2px rgba(255, 78, 58, 0.2) !important;
  }`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,kDAAkD;IAClD,WAAW;IACX,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gDAAgD;EAClD;;EAEA;IACE,YAAY;IACZ,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,YAAY;EACd;;EAEA;;;;IAIE,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,uDAAuD;EACzD","sourcesContent":["/* Sidebar.css */\n.sidebar-root {\n    position: static;\n    height: 100vh;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    display: flex;\n    flex-direction: column;\n    font-size: 15px;\n    z-index: 10000;\n    box-shadow: 0px 10px 16px 4px rgba(4, 0, 43, 0.07);\n    width: 70px;\n    overflow: visible;\n    transition: width 2s ease;\n  }\n  \n  .sidebar-root.collapsed {\n    width: 70px;\n    transition: width 0.3s cubic-bezier(0.4,0,0.2,1);\n  }\n  \n  .sidebar-root.expanded {\n    width: 18rem;\n    transition: width 0.3s cubic-bezier(0.4,0,0.2,1);\n  }\n  \n  .sidebar-logo {\n    flex-direction: row;\n    width: 9vw;\n    height: 9vh;\n    padding-left: 4vh;\n  }\n  \n  .dark-sidebar-menu-text {\n    padding-top: 4vh;\n    margin-bottom: 1vh;\n    letter-spacing: 0.5px;\n  }\n  \n  .light-sidebar-menu-text {\n    padding-top: 4vh;\n    margin-bottom: 2vh;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n  \n  .sidebar-menu-items {\n    padding-left: 2vh;\n    padding-right: 2vh;\n  }\n  \n  .sidebar-active-menu {\n    display: flex;\n    padding: 0.9vh;\n    background-color: #ff4e3a;\n    color: #ffffff;\n    border-radius: 0.8vh;\n    margin: 1.6vh;\n    cursor: pointer;\n    align-items: center;\n  }\n  \n  .sidebar-in-active-menu {\n    display: flex;\n    padding: 0.5vh;\n    border-radius: 1vh;\n    margin: 2vh;\n    cursor: pointer;\n    align-items: center;\n  }\n  \n  .sidebar-home-icon,\n  .sidebar-home-icon2 {\n    width: fit-content;\n    height: 1rem;\n  }\n  \n  .sidebar-root,\n  .sidebar-menu-items,\n  .sidebar-home-icon,\n  .sidebar-home-icon2 {\n    transition: opacity 2s ease;\n  }\n\n  .ant-switch-checked {\n    background-color: #ff4e3a !important;\n  }\n  \n  .ant-switch-checked:hover:not(.ant-switch-disabled) {\n    background-color: #ff4e3a !important;\n  }\n  \n  .ant-switch-checked:focus {\n    box-shadow: 0 0 0 2px rgba(255, 78, 58, 0.2) !important;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
